import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../../HomePage/Faq/Faq.css";
const CommercialDocsAttestationFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is a Commercial Document Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              Commercial attestation is the process of validating
              business-related documents—such as invoices, certificates of
              origin, MoUs, power of attorney, and company registration
              papers—for use abroad.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Why do I need commercial attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              It is mandatory for business expansion, exporting goods, opening a
              branch abroad, trade agreements, bank procedures, and company
              legal verification in foreign countries.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Which commercial documents require attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Common documents include:
              <ul>
                <li> Certificate of Incorporation</li>
                <li> Board Resolution</li>
                <li> Power of Attorney</li>
                <li> Commercial Invoice</li>
                <li> Packing List</li>
                <li> Certificate of Origin</li>
                <li> Memorandum/Articles of Association (MoA/AoA)</li>
                <li> Company Agreements / MoUs</li>
                <li> Bank Statements for Business</li>
              </ul>
              Requirement varies based on the destination country.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Who attests commercial documents in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Typically:
              <ul>
                <li> Notary Public</li>
                <li> Chamber of Commerce (CoC)</li>
                <li> State/MEA (Ministry of External Affairs)</li>
                <li> Embassy of the destination country</li>
              </ul>
              Professional attestation agencies handle the entire workflow.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Do I need to visit the police station for PCC?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Not always.
              <br />
              For many, PCC is issued based on Passport Seva Kendra (PSK) police
              verification at home. You may need to visit the police station
              only if:
              <ul>
                <li> Address mismatch</li>
                <li> Pending verification</li>
                <li> Supporting document clarification</li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does commercial attestation take? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              General timeline: 3–12 working days, depending on:
              <ul>
                <li> Destination country</li>
                <li> Chamber of Commerce processing</li>
                <li> Embassy workload</li>
              </ul>
              Countries like UAE, Qatar, and Kuwait may take slightly longer.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is the cost of commercial attestation in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Cost depends on:
              <ul>
                <li> Type of document</li>
                <li> Number of documents</li>
                <li> Chamber of Commerce + Embassy fee</li>
                <li> Urgent/Normal processing</li>
              </ul>
              Prices usually start from ₹1,500 and can go up depending on
              embassy charges.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Can I get commercial documents attested urgently?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Many agencies offer express services with 1–3 day fast-track
              processing (depending on embassy rules).
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Do you offer free pickup and delivery in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Most ISO- and government-approved attestation agencies provide
              free document pickup & drop, especially in key business areas like
              MG Road, Koramangala, Whitefield, Jayanagar, and Electronic City.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Is commercial attestation safe? How are documents handled?{" "}
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Reputed agencies use:
              <ul>
                <li> Barcode-based tracking</li>
                <li> Secure lockers</li>
                <li> Digital status updates</li>
                <li> Signed receipts</li>
              </ul>
              Always choose an authorized and MEA-recognized service provider.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What are the steps involved in commercial attestation? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              The full process usually includes:
              <ul>
                <li> Notarization</li>
                <li> Chamber of Commerce Attestation</li>
                <li> MEA Attestation</li>
                <li> Embassy Attestation</li>
                <li> MOFA (if required by the destination country)</li>
              </ul>
              Professional agencies manage end-to-end documentation and
              coordination.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default CommercialDocsAttestationFaqMain;
